import type {GetAdditionalChartkitErrorContent} from 'ui/registry/units/common/types/functions/getAdditionalChartkitErrorContent';

export const getAdditionalChartkitErrorContent: GetAdditionalChartkitErrorContent = () => {
    return {};
};
